<template>
  <div class="contents">
    <!-- componentに追加したものはタグとして使用できるようになる -->
    <Canvas ref="canvas" :imageNo='writeImageNo' :backgroundImage="imageFile" @toggleContentsVisible="toggleContentsVisible" />
    <!-- <div class="scroll"></div> -->
  </div>
</template>
<script>
import Canvas from './paint/Canvas.vue' // 作成したCanvas.vueをインポート
export default {
  name: 'Main',
  props: {
    imageNo: {
      type: Number
    }
  },
  data () {
    return {
      writeImageNo: this.imageNo
    }
  },
  components: {
    Canvas // componentsにインポートしたCallCanvasを追加する。
  },
  created: function () {
    this.debug(this.imageNo)
  },
  computed: {
    imageFile: function () {
      this.debug('イメージ画像パス : @/assets/wja/page/writingjapaneseanimal_' + this.writeImageNo + '_optimized.jpg')
      return require('@/assets/wja/page/writingjapaneseanimal_' + this.writeImageNo + '_optimized.jpg')
    }
  },
  methods: {
    // キャンバスをクリアする
    onClearCanvas: function () {
      this.$refs.canvas.onClearCanvas()
    },
    toggleContentsVisible: function () {
      this.$emit('toggleContentsVisible')
    },
    nextCanvas: function () {
      // 次の画像を呼び出す
      this.debug('nextCanvas : 次の画像を呼び出しました')
      if (this.writeImageNo + 1 <= this.getMaxImage()) {
        this.writeImageNo++
      } else {
        // ループする
        this.writeImageNo = 1
      }
      this.debug('遷移先に受け渡す値 : this.writeImageNo : ' + this.writeImageNo)
      this.$emit('selectRedirect', this.writeImageNo)
    },
    beforeCanvas: function () {
      // 前の画像を呼び出す
      this.debug('beforeCanvas : 前の画像を呼び出しました')
      if (this.writeImageNo - 1 > 0) {
        this.writeImageNo--
      } else {
        // ループする
        this.writeImageNo = this.getMaxImage()
      }
      this.debug('遷移先に受け渡す値 : this.writeImageNo : ' + this.writeImageNo)
      this.$emit('selectRedirect', this.writeImageNo)
    }
  }
}
</script>
<style lang="scss" scoped>
  .contents {
    width: 100%;
    // margin: 80px , 0px;
    // margin-top: 80px;
    margin-bottom: 80px;
    // padding-right: 80px;
    background-color: white;
    z-index:  1;
  }
  .scroll {
    width: 20px;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1000;
    border-bottom: double 3px;
    background-color: gray;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue